/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  allowHalf: Boolean,
  color: {
    type: [String, Array],
    "default": "#ED7B2F"
  },
  count: {
    type: Number,
    "default": 5
  },
  disabled: Boolean,
  gap: {
    type: Number,
    "default": 4
  },
  icon: {
    type: Function
  },
  showText: Boolean,
  size: {
    type: String,
    "default": "24px"
  },
  texts: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  value: {
    type: Number,
    "default": void 0
  },
  defaultValue: {
    type: Number,
    "default": 0
  },
  onChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/rate/props.js
// module id = null
// module chunks = 